export const createRandomId = () => {
  return (
    (Math.random() * 10000000).toString(16).substr(0, 4) +
    '_' +
    new Date().getTime() +
    '_' +
    Math.random()
      .toString()
      .substr(2, 5)
  )
}

export const splitTime = (time) => {
  let timeArr = time.split(' ')
  let sp = timeArr[1].split(':')
  return `${timeArr[0]} ${sp[0]}:${sp[1]}`
}

export const dateFormat = (fmt, date,type = 'number') => {
  if(type === 'string'){
    date = new Date(date);
  }
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
      )
    }
  }
  return fmt
}
